import { secondAxios as axios } from "../../../../../../api/axios";
import { tokenHeader } from "../../../../Project/allProjectsPage/ProjectsTable/ProjectTasksPage/tokenHeader";
import { authStore } from "../../../../../../context/authContext/authStore";
import { normalizeSi } from "./siUtils";

/** Extract si from common API response shapes; undefined when not present. */
export function parseSiFromResponse(data) {
  if (data == null) return undefined;

  const payload =
    typeof data === "object" && data !== null
      ? (data.data ?? data.task ?? data)
      : data;

  if (typeof payload === "object" && payload != null && "si" in payload) {
    return normalizeSi(payload.si);
  }

  if (
    typeof payload === "number" ||
    typeof payload === "boolean" ||
    typeof payload === "string"
  ) {
    return normalizeSi(payload);
  }

  return undefined;
}

/**
 * Toggle task SI via PATCH /si/:taskId (backend toggles 0 ↔ 1).
 * Returns normalized si (0 | 1) when the response includes it, else undefined.
 */
export async function toggleTaskSi({ taskId, accessToken }) {
  if (!taskId) {
    throw new Error("taskId is required to toggle SI");
  }

  const token = accessToken || authStore.getToken();
  const authConfig = token ? tokenHeader(token) : {};

  const { data } = await axios.patch(`/task/si/${taskId}`, {}, authConfig);
  return parseSiFromResponse(data);
}
